<template>
  <VDialog
    :value="show"
    max-width="720"
    @input="$emit('close')"
    style="z-index:999;"
  >
    <VCard>
      <VCardTitle class="blue darken-1 white--text">
        <h3 class="r-title">Media Gallery</h3>
        <VSpacer />
        <a href="#" class="white--text" @click.prevent="$emit('close')"
          >&times;</a
        >
      </VCardTitle>
      <VCardText class="pa-4">
        <div v-if="loading" class="text-xs-center pa-4">
          <BaseLoader />
        </div>
        <div v-else-if="assets.length === 0" class="text-xs-center pa-4">
          <p>No images uploaded yet for this site.</p>
        </div>
        <div v-else class="media-gallery-grid">
          <div
            v-for="asset in assets"
            :key="asset.public_id"
            class="media-gallery-item"
            :class="{ 'is-selected': selectedPublicId === asset.public_id }"
            @click="selectedPublicId = asset.public_id"
          >
            <img :src="asset.thumbnail_url" :alt="asset.file_name" />
            <div class="media-gallery-item-name">{{ asset.file_name }}</div>
          </div>
        </div>
      </VCardText>
      <VCardActions v-if="assets.length > 0" class="pa-3">
        <VSpacer />
        <BaseButtonOutline small @click="$emit('close')">
          Cancel
        </BaseButtonOutline>
        <BaseButton
          color="blue"
          small
          :disabled="!selectedPublicId"
          @click="selectAsset"
        >
          Use Selected Image
        </BaseButton>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import VDialog from '@vuetify/VDialog'
import { VCardText, VCardActions } from '@vuetify/VCard'
import api from '@services/api'

export default {
  name: 'MediaGalleryModal',
  components: { VDialog, VCardText, VCardActions },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    siteId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      assets: [],
      loading: false,
      selectedPublicId: null,
    }
  },
  watch: {
    show(visible) {
      if (visible) {
        this.selectedPublicId = null
        this.fetchAssets()
      }
    },
  },
  methods: {
    async fetchAssets() {
      this.loading = true
      try {
        const { data } = await api.get('media-gallery', {
          params: { site_id: this.siteId },
        })
        this.assets = data.filter((a) => this.isImageFile(a.file_name))
      } catch {
        this.assets = []
      } finally {
        this.loading = false
      }
    },
    isImageFile(fileName) {
      return /\.(jpe?g|png|gif|webp|svg)$/i.test(fileName)
    },
    selectAsset() {
      const asset = this.assets.find(
        (a) => a.public_id === this.selectedPublicId
      )
      if (asset) {
        this.$emit('select', asset)
      }
    },
  },
}
</script>

<style scoped>
.media-gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}
.media-gallery-item {
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s;
}
.media-gallery-item:hover {
  border-color: #90caf9;
}
.media-gallery-item.is-selected {
  border-color: #1976d2;
}
.media-gallery-item img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  display: block;
}
.media-gallery-item-name {
  padding: 4px 6px;
  font-size: 11px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
